module.exports = __webpack_public_path__ + "img/rock.3bdc137e.png";